import { h } from 'preact'
import { ModulesContext } from '../../utils/globals'
import Phrase from '../../libs/translationsUtils/phrase'

interface Props {
  id: number | null
  topicsCount: number
  repliesCount: number
  solvedCount: number
  pmUnreadCount: number
  pmTotalCount: number
}

export default function Dropdown (user: Props) {
  return (
    <ModulesContext.Consumer>
      {modules =>
        <div class='dropdown dropdown--profile is-hidden qa-header-profile-dropdown'>
          <span class='arrow is-hidden-S' />
          <div class='user flag '>
            <div class='user_data flag__body'>
              <a href={`/members/user-${user.id}`} class='link--text qa-menu-username'><Phrase p='My profile' /></a>
            </div>
          </div>
          <ul class='list--menu'>

            <li class='list__item qa-menu-user-topics'>
              <a
                class='link--text'
                href={`/search/activity/topics?userid=${user.id}`}
              >
                <span><Phrase p='Topic|Topics' count={{ c: user.topicsCount }} /></span>
                <span class='counter'>{user.topicsCount}</span>
              </a>
            </li>
            <li class='list__item qa-menu-user-reactions'>
              <a
                class='link--text'
                href={`/search/activity/reactions?userid=${user.id}`}
              >
                <span><Phrase p='Reply|Replies' count={{ c: user.repliesCount }} /></span>
                <span class='counter'>{user.repliesCount}</span>
              </a>
            </li>
            <li class='list__item qa-menu-user-solved'>
              <a
                class='link--text'
                href={`/search/activity/solved?userid=${user.id}`}
              >
                <span><Phrase p='Solved' count={{ c: user.solvedCount }} /></span>
                <span class='counter'>{user.solvedCount}</span>
              </a>
            </li>

            <li class='list__item qa-menu-favorites'>
              <a class='link--text' href='/favorites/overview'>
                <Phrase p='header.profile.dropdown.subscriptions' />
              </a>
            </li>

            {modules.includes('privateMessage')
              ? <li class='list__item qa-menu-private-messages'>
                <a
                  class='link--text messages {% if App.user.person.pmunread > 0 %}counter-alert{% endif %}'
                  href='/inbox/overview'
                >
                  <span><Phrase p='Private messages' /></span>
                  <span class='counter'>
                    {user.pmUnreadCount ? `${user.pmUnreadCount} /` : null}
                    {user.pmTotalCount}
                  </span>
                </a>
              </li>
              : null}

            <li class='list__item list__item--border-top qa-menu-settings'>
              <a class='link--text' href='/settings/profile'>
                <Phrase p='Settings' />
              </a>
            </li>

            <li class='list__item qa-menu-logout'>
              <a class='link--text' href='/member/logout' onClick={() => sessionStorage.setItem('UserLoggedOut', 'true')}>
                <Phrase p='Logout' />
              </a>
            </li>
          </ul>
        </div>}
    </ModulesContext.Consumer>
  )
}
